define('utils/content-slider', [
    'jquery',
    'underscore',
    'velocity',
    'velocity.ui'
],  function ($, _, Velocity, VelocityUi) {
    'use strict';

    console.log('%cfile: content-slider.js', 'color: #C2ECFF');

    var contentSlider = function contentSlider() {
        console.log('%ctrace: contentSlider', 'color: #ccc');

        var el = '[data-content-slider]',
            link = '[data-content-slider-link]',
            prev = '[data-content-slider-prev]',
            next = '[data-content-slider-next]',
            wrap = '[data-content-slider-wrap]',
            item = '[data-content-slider-item]',

            $el = $(el),
            $link,
            $prev,
            $next,
            $wrap,
            $item,

            api = {
                renderBeginCallback: function (id) {
                    console.log(id);
                }
            };

        if($el.length <= 0){
            console.warn('%ctrace: contentSlider: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });

        function initialize($el){
            var $link = $el.find(link),
                $prev = $el.find(prev),
                $next = $el.find(next),
                $wrap = $el.find(wrap),
                $item = $el.find(item),

                itemsLength = $item.length;

            if(itemsLength <= 0){
                return false;
            }

            if (!$item.is('.active')) {
                $item.eq(0).addClass('active');
                $item.eq(0).find(link).eq(0).addClass('active');
            }

            $prev.attr('data-content-slider-prev', $item.eq(itemsLength - 1).attr('data-content-slider-item'));
            $next.attr('data-content-slider-next', $item.eq(1).attr('data-content-slider-item'));

            $wrap.css('height', $item.filter('.active').outerHeight());

            $link.off('click').on('click', function(e){
                e.preventDefault();

                var link = $(this).attr('data-content-slider-link');

                render($el, $wrap, $item, $link, link, $prev, $next);
            });

            $prev.off('click').on('click', function(e){
                e.preventDefault();

                var link = $(this).attr('data-content-slider-prev');

                render($el, $wrap, $item, $link, link, $prev, $next);
            });

            $next.off('click').on('click', function(e){
                e.preventDefault();

                var link = $(this).attr('data-content-slider-next');

                render($el, $wrap, $item, $link, link, $prev, $next);
            });
        }

        function render($el, $wrap, $item, $link, link, $prev, $next){
            var $nextItem = $item.filter('[data-content-slider-item="' + link + '"]'),
                itemsLength = $item.length,
                nextItemIndex = $item.index($nextItem),
                prev = $item.eq(nextItemIndex - 1).attr('data-content-slider-item'),
                next = $item.eq(nextItemIndex + 1).attr('data-content-slider-item');

            if (nextItemIndex >= itemsLength - 1) {
                next = $item.eq(0).attr('data-content-slider-item');
            }

            if (nextItemIndex === 0) {
                prev = $item.eq(itemsLength - 1).attr('data-content-slider-item');
            }

            $item.filter('.active').velocity('stop').velocity('fadeOut', {
                duration: 300,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                    $wrap.css('height', $item.filter('.active').outerHeight());

                    $link.removeClass('active');
                    $link.filter('[data-content-slider-link="' + link + '"]').addClass('active');

                    api.renderBeginCallback(link);
                },
                complete: function(){
                    $item.removeClass('active');
                    $item.filter('[data-content-slider-item="' + link + '"]').addClass('active');
                }
            });

            $item.filter('[data-content-slider-item="' + link + '"]').velocity('stop').velocity('fadeIn', {
                duration: 300,
                delay: 150,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                    $item.filter('[data-content-slider-item="' + link + '"]').css('position', 'absolute');
                    $item.filter('[data-content-slider-item="' + link + '"]').css('top', 0);
                },
                complete: function(){
                    $item.filter('[data-content-slider-item="' + link + '"]').css('position', '');
                    $item.filter('[data-content-slider-item="' + link + '"]').css('top', '');
                    $wrap.css('height', $item.filter('[data-content-slider-item="' + link + '"]').outerHeight());

                    $prev.attr('data-content-slider-prev', prev);
                    $next.attr('data-content-slider-next', next);
                }
            });
        }

        return api;
    };

    return contentSlider;
});

